var $ = require('jquery');
var scrolled=0;
$(document).ready(function(){    	
    $(".down-arrow-indicator").on("click" ,function(){
        scrolled=scrolled+600;        
        $("html, body").animate({
            scrollTop:  scrolled
        });
    });
    var scrollTop = $(".down-arrow-indicator");
        $(window).scroll(function () {
            // declare variable
            var topPos = $(this).scrollTop();
            // if user scrolls down - show scroll to top button
            if (topPos < 100) {
                $(scrollTop).css("opacity", "1");
            } else {
                $(scrollTop).css("opacity", "0");
            }
        });
    
});